module.exports = __webpack_public_path__ + "static/img/noimage.8a2f350.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/noimage.jpg
// module id = Q0KG
// module chunks = 19